import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

export function Card({ children, className = '', padding = true }: CardProps) {
  return (
    <div className={`rounded-xl border border-silver-200 bg-white shadow-sm ${padding ? 'p-6' : ''} ${className}`}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function CardHeader({ title, description, action }: CardHeaderProps) {
  return (
    <div className="flex items-center justify-between pb-4">
      <div>
        <h3 className="text-lg font-semibold text-silver-900">{title}</h3>
        {description && <p className="mt-1 text-sm text-silver-500">{description}</p>}
      </div>
      {action}
    </div>
  );
}
